import * as angular from 'angular';

const DatalayerBKIConstants =  {
    MEMBER: 'Member',
    SEARCH_OD: 'SearchOD',
    SEARCH_COUNTRIES: 'SearchCountries',
    SEARCH_CITY: 'SearchCity',
    SEARCH_COUNTRY: 'SearchCountry',
    SEARCH_DEST: 'SearchDest',
    SEARCH_DEST_NAME: 'SearchDestName',
    SEARCH_ORIGIN: 'SearchOrigin',
    SEARCH_ORIGIN_NAME: 'SearchOriginName',
    SEARCH_TYPE: 'SearchType',
    FLIGHT_HAUL: 'FlightHaul',
    FLIGHT_TYPE: 'FlightType',
    // OUTBOUND_ROUTE: 'OutboundRoute',
    // INBOUND_ROUTE: 'InboundRoute',
    // OUTBOUND_FARE_FAMILY: 'OutboundFareFamily',
    // INBOUND_FARE_FAMILY: 'InboundFareFamily',
    // CABIN: 'Cabin',
    // OUTBOUND_CABIN: 'OutboundCabin',
    // INBOUND_CABIN: 'InboundCabin',
    // FARE_NAME: 'FareName',
    // OUTBOUND_FARE_NAME: 'OutboundFareName',
    // INBOUND_FARE_NAME: 'InboundFareName',
    CHEAPEST_FARE: 'CheapestFare',
    // STOPOVER: 'Stopover',
    // OUTBOUND_STOPOVER: 'OutboundStopover',
    // INBOUND_STOPOVER: 'InboundStopover',
    // FLIGHT_SCHEDULE: 'FlightSchedule',
    // OUTBOUND_FLIGHT_SCHEDULE: 'OutboundFlightSchedule',
    // INBOUND_FLIGHT_SCHEDULE: 'InboundFlightSchedule',
    // IDENTIFIER: 'Identifier',
    // OUTBOUND_FLIGHTS: 'OutboundFlights',
    // INBOUND_FLIGHTS: 'InboundFlights',
    // FLIGHTS_OPERATOR: 'FlightOperator',
    // OUTBOUND_OPERATOR: 'OutboundOperator',
    // INBOUND_OPERATOR: 'InboundOperator',
    // OUTBOUND_RESULTS: 'OutboundResults',
    // INBOUND_RESULTS: 'IntboundResults',
    // FLIGHT_DATE: 'FlightDate',
    // OUTBOUND_DATE: 'OutboundDate',
    // INBOUND_DATE: 'InboundDate',
    ADVANCE_PURCHASE: 'AdvancePurchase',
    LENGTH_STAY: 'LengthStay',
    LARGE_FAMILY: 'LargeFamily',
    RESIDENT_CODE: 'ResidentCode',
    PAX_YOUNG: 'PaxYoung',
    PAX_ADULT: 'PaxAdult',
    PAX_INFANT: 'PaxInfant',
    PAX_CHILD: 'PaxChild',
    PAX_SENIOR: 'PaxSenior',
    PAX_TOTAL: 'PaxTotal',
    DYNAMIC_PRICING: 'DynamicPricing',
    DYNAMIC_PRICING_SEAT: 'Dynamic_pricing_seat',
    PROCESS_START: 'ProcessStart',
    IBPLUS_HOLDER: 'IbplusHolder',
    PAX_PRICE: 'PaxPrice',
    TOTAL_PRICE: 'TotalPrice',
    TOTAL_PRICE_WITHOUT_TAXES: 'TotalPriceWithoutTaxes',
    TOTAL_TAXES: 'TotalTaxes',
    ELIGIBLE_VOUCHER: 'EligibleVoucher',
    RECOVERY_LINK: 'RecoveryLink',
    PROVIDER: 'Provider',
    CASH_AVIOS_OFFER: 'CashAviosOffer',
    VOUCHER_CODE_MERGED: 'VoucherCodeMerged',
    VOUCHER_CODE_TO_UNIFY: 'VoucherCodeToUnify',
    MERGED_BONUS_BALANCE: 'MergedBonusBalance',
    VOUCHER_RECORD: 'VoucherRecord',
    PRICE_PAID: 'PricePaid',
    POLICY: 'Policy',
    INSURANCE_TYPE: 'InsuranceType',
    INSURANCE_PRICE: 'InsurancePrice',
    INSURANCE_TOTAL_PRICE: 'InsuranceTotalPrice',
    INSURANCE_PROVIDER: 'InsuranceProvider',
    FLEXIBLE_TICKET: 'FlexibleTicket',
    TOTAL_FLEXIBLE_TICKET: 'TotalFlexibleTicket',
    BOARDING_PRIORITY: 'BoardingPriority',
    TOTAL_BOARDING_PRIORITY: 'TotalBoardingPriority',
    STOPOVER_LEG: 'StopoverLeg',
    NIGHTS: 'Nights',
    PMR: 'pmr',
    AVIOS_DISCOUNT: 'AviosDiscount',
    VOUCHER_DISCOUNT: 'VoucherDiscount',
    GIFT_CARD: 'GiftCard',
    TOTAL_PRICE_GIF_CARD: 'TotalPriceGifCard',
    REFERENCE_GIF_CARD: 'ReferenceGifCard',
    EXPIRY_GIF_CARD: 'ExpiryGifCard',
    BENEFICIARY_GIF: 'BeneficiaryGift',
    IBP_BUSINESS_SCORING: 'ibp_business_scoring',
    IBP_LEISURE_SCORING: 'ibp_leisure_scoring',
    SLICE_1_RESULTS: 'Slice1Results',
    SLICE_2_RESULTS: 'Slice2Results',
    OFFERDEST: 'OfferDest',
    OFFERDESTNAME: 'OfferDestName',
    PROCESS: 'Process',
    AVIOS_EARNED: 'AviosEarned',
    PURCHASE_TYPE: 'PurchaseType'
};

angular.module('ib-datalayer-module').constant('DatalayerBKIConstants', DatalayerBKIConstants);
export type DatalayerBKIConstantsType = typeof DatalayerBKIConstants;
export { DatalayerBKIConstants };
